export const API_URL = "https://devcp.emailarray.com/admin/json.php";
export default API_URL;
